import React from 'react';

// حالات خلايا مصفوفات تقارير التقدّم — نفس دلالات النموذج المطبوع:
// تم الإنجاز / قيد العمل / لم يبدأ / متوقف حالياً
export const PR_STATUSES = {
  done: { label: 'تم الإنجاز', glyph: '✓', cls: 'report-icon-done' },
  in_progress: { label: 'قيد العمل', glyph: '◔', cls: 'report-icon-active' },
  not_started: { label: 'لم يبدأ العمل عليه', glyph: '✕', cls: 'report-icon-todo' },
  paused: { label: 'متوقف حالياً', glyph: '⏸', cls: 'report-icon-paused' },
};

export const PR_CYCLE = [null, 'done', 'in_progress', 'not_started', 'paused'];

// تغميق hex لاشتقاق طرف التدرّج الداكن من اللون الأساسي
const darken = (hex, f) => {
  const n = parseInt(hex.slice(1), 16);
  const ch = (v) => Math.round(v * (1 - f));
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(ch);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};

// متغيرات CSS لثيم التقرير — تُطبّق على جذر الصفحة فتسري على كل عناصر report-*
export function prThemeVars({ primary_color: primary, accent_color: accent } = {}) {
  return {
    ...(primary ? { '--report-green': primary, '--report-green-dark': darken(primary, 0.3) } : {}),
    ...(accent ? { '--report-gold': accent } : {}),
  };
}

export function PrStatusIcon({ status, text, onClick, title }) {
  if (text != null && text !== '') {
    return <span style={{ fontWeight: 600 }} onClick={onClick}>{text}</span>;
  }
  if (!status) {
    return (
      <span
        onClick={onClick}
        title={title}
        style={{ color: 'var(--border-strong)', cursor: onClick ? 'pointer' : undefined, display: 'inline-block', minWidth: 22 }}
      >—</span>
    );
  }
  const s = PR_STATUSES[status] || PR_STATUSES.not_started;
  return (
    <span
      className={`report-icon ${s.cls}`}
      title={title || s.label}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >{s.glyph}</span>
  );
}

export function PrLegend() {
  return (
    <div className="report-legend">
      {Object.entries(PR_STATUSES).map(([k, s]) => (
        <span key={k}><span className={`report-icon ${s.cls}`}>{s.glyph}</span> {s.label}</span>
      ))}
    </div>
  );
}

// مصفوفة عرض للقراءة فقط (تُستخدم في البوابة والمعاينة)
// اللون: لون الجدول نفسه، ثم لون القسم (المشروع)، ثم الافتراضي
export function PrMatrixTable({ matrix, sectionColor }) {
  const color = matrix.color || sectionColor || null;
  const headStyle = color ? { background: color } : undefined;
  return (
    <div className="report-table-wrap">
      {matrix.title && <div className="report-table-title" style={headStyle}>{matrix.title}</div>}
      <div className="table-wrap">
        <table className="report-matrix">
          <thead>
            <tr>
              <th className="report-matrix-rowhead" style={headStyle}>البيــان</th>
              {matrix.columns.map((c, i) => <th key={i} style={headStyle}>{c}</th>)}
            </tr>
          </thead>
          <tbody>
            {matrix.rows.map((r, i) => (
              <tr key={i}>
                <td className="report-matrix-rowhead">{r.label}</td>
                {r.cells.map((cell, j) => (
                  <td key={j} className="report-matrix-cell">
                    <PrStatusIcon status={cell.status} text={cell.text} />
                  </td>
                ))}
              </tr>
            ))}
            {matrix.rows.length === 0 && (
              <tr><td colSpan={matrix.columns.length + 1} style={{ color: 'var(--text-faint)' }}>لا بنود بعد</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
